import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { HomeState } from '../../types/features/homeSlice';
import { HomeResponse } from '../../types/api/homeApi';
import { getHomeDataService } from '../../api/homeApi';


export const getHomeData = createAsyncThunk<HomeResponse>(
    'home/getHomeData',
    async () => {
        const response = await getHomeDataService();
        return response.data; // Assumes response has a 'data' property
    }
);

const homeSlice = createSlice({
    name: 'home',
    initialState: {
        homeLoader: false,
        room_types: [],
        testimonials: [],
        articles: [],
        special_offers: [],
        our_services: [],
        amenities: [],
        home_data: {
            aboutUs: {
                name: '',
                description: '',
                facility: [],
                link: '#'
            },
            rooms_description: {
                name: '',
                description: '',
                link: '#'
            }
        },
        status: false,
        msg: ''
    } as HomeState, // Type the initialState with AuthState
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getHomeData.pending, (state) => {
                state.homeLoader = true;
            })
            .addCase(getHomeData.fulfilled, (state, action: PayloadAction<HomeResponse>) => {
                state.room_types = action.payload.room_types;
                state.testimonials = action.payload.testimonials;
                state.articles = action.payload.articles;
                state.special_offers = action.payload.special_offers;
                state.our_services = action.payload.our_services;
                state.amenities = action.payload.amenities;
                state.home_data = action.payload.home_data;
                state.msg = action.payload.message;
                state.status = true;
                state.homeLoader = false;
            })
            .addCase(getHomeData.rejected, (state, action) => {
                state.homeLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })
    }
});

export default homeSlice.reducer;
